import { render } from "./GoodsView.vue?vue&type=template&id=517cbf1e"
import script from "./GoodsView.vue?vue&type=script&lang=js"
export * from "./GoodsView.vue?vue&type=script&lang=js"

import "./GoodsView.vue?vue&type=style&index=0&id=517cbf1e&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__